import Vue from 'vue'
import Vuex from 'vuex'

import cookie from 'vue-cookies'
import router from '@/router/index'

import crm from './modules/crm'
import elvira from './modules/elvira'
import fpm from './modules/fpm'
import pda from './modules/pda'
import plan from './modules/plan'
import prm from './modules/prm'
import ptb from './modules/ptb'
import qmd from './modules/qmd'
import time from './modules/time'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    redirectPath: '',
    loggedIn: sessionStorage.getItem('loggedIn') || '',
    allApps: [],
    allUser: JSON.parse(sessionStorage.getItem('allUser')) || [],
    user: null,
    admin: false,
    loading: false,
    message: '',
    toastMsg: { title: '', msg: [], color: '' },
    maxFileSize: 0,
    // header
    searchField: '',
    searchHistory: JSON.parse(sessionStorage.getItem('searchHistory')) || [],
    dateField: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substring(0, 10),
    numberField: 100,
    cronjob: sessionStorage.getItem('cronjob') || true,
    // eventSource
    loginSource: null,
    windowHeight: 600,

    _timerId: null,
    doNotShowLoading: [
      'pisa/online/click',
      'statistic/newclicks',
      'statistic/userclicks/info',
      'draw/update',
      'pisa/file',
      'elvira/order/info',
      'fpm/order/info',
      'pda/moveto',
      'pda2/moveto',
    ],
    doNotMatch: [
      'plan/calcs',
      'pda/foldercontent',
      'pda/content',
      'pda/versions',
      'pda/path',
      'plan/payments/close',
      'draw/ressource',
    ],
  },

  getters: {
    loggedIn: (state) => {
      // state.loggedIn = 'tmaiss'
      // state.loggedIn = 'infortime'
      // state.loggedIn = 'sbradaric'
      // state.loggedIn = 'tbkr'
      // state.loggedIn = 'fschmidt'
      // state.loggedIn = 'j.kraus'
      // state.loggedIn = 'kfeigl'
      // state.loggedIn = 'thgu'
      // state.loggedIn = 'bach'
      // state.loggedIn = 'umueller'
      // state.loggedIn = 'tbwe'
      // state.loggedIn = 'geoec'
      // state.loggedIn = 's.meyer-rummel'
      // state.loggedIn = 'cstoian'
      return state.loggedIn
    },
    apps: (state) => state.allApps,
    appValue: (state) => (appId, value) => {
      let app = state.allApps.find((app) => app.id == appId.toLowerCase())
      return app !== undefined ? app[value] : appId.toUpperCase()
    },
    user: (state) => state.user,
    admin: (state) => state.admin,
    loading: (state) => state.loading,
    message: (state) => state.message,
    toastMsg: (state) => state.toastMsg,
    maxFileSize: (state) => state.maxFileSize,
    allUser: (state) => state.allUser,
    activeUsers: (state) =>
      state.allUser.filter(
        (user) => user.status.hasRights && !user.id.match(/Terminal/)
      ),
    searchField: (state) => state.searchField,
    searchHistory: (state) => state.searchHistory,
    dateField: (state) => state.dateField,
    numberField: (state) => state.numberField,
    getUserApps: (state) => {
      return state.allApps.filter((app) => state.user?.rights[app.id] > 0)
    },
    cronjob: (state) => state.cronjob,
    // compare two values (fpm / elvira)
    compareNotes: () => (from, to) => {
      if (to == '' && from == '') {
        return ''
      } else if (to != '' && from != '') {
        if (!to.match(new RegExp(from, 'gim'))) {
          return to + ' / ' + from
        } else {
          return to
        }
      } else if (to != '') {
        return to
      } else {
        return from
      }
    },
    // filter
    FULLNAME: (state) => (userId) =>
      state.allUser.find((user) => user.id == userId)?.name || userId,
    INITIALS: (state) => (userId) => {
      if (userId == 'System') return 'S'
      return (
        state.allUser
          .find((user) => user.id == userId)
          ?.name.replace(/([A-ZÄÖÜ]).*?([A-ZÄÖÜ])(.*)/, '$1$2') || userId
      )
    },
    AVATAR: (state) => (userId) =>
      state.allUser.find((user) => user.id == userId)?.avatar || null,
    MAIL: (state) => (userId) =>
      state.allUser.find((user) => user.id == userId)?.mail || userId,
    CURRENCY: () => (value) =>
      parseFloat(value).toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }),
    DECIMAL: () => (value) =>
      parseFloat(value).toLocaleString('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    FILESIZE: () => (value) => {
      let i = 0
      let units = ['Bytes', 'KB', 'MB', 'GB', 'TB']

      while (value > 1024) {
        value /= 1024
        i++
      }

      return (
        parseFloat(value).toLocaleString('de-DE', {
          style: 'decimal',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }) +
        ' ' +
        units[i]
      )
    },
    SAVEPATH: () => (id, ext) =>
      'UP' +
      (parseInt(id / 1024) * 1024)
        ?.toString(16)
        .padStart(8, '0')
        .toUpperCase()
        .substring(0, 6) +
      '/' +
      parseInt(id)?.toString(16).padStart(8, '0').toUpperCase() +
      '.' +
      ext,
    EXTENTION: () => (name) => name.split('.').pop().toLowerCase(),
    // eventSource
    loginSource: (state) => state.loginSource,
    windowHeight: (state) => state.windowHeight,
  },
  mutations: {
    setRedirectPath: (store, path) => (store.redirectPath = path),
    setLoggedIn(state, userId) {
      state.loggedIn = userId
      sessionStorage.setItem('loggedIn', userId)
    },
    setCookie(state) {
      const crypto = require('crypto')
      let md5 = crypto.createHash('md5').update(state.loggedIn).digest('hex')
      cookie.set('remember', md5, '3m')
    },
    setAllApps: (state, apps) =>
      (state.allApps = apps.sort((a, b) => (a.title > b.title ? 1 : -1))),
    setAllUser(state, user) {
      state.allUser = user
      sessionStorage.setItem('allUser', JSON.stringify(user))
    },
    setUser(state, data) {
      if (data !== null) {
        state.user = data.user
        // apiToken
        Vue.prototype.$axios.defaults.headers.Authorization = data.apiToken
      } else state.user = data
    },
    setAdmin: (state, value) => (state.admin = value),
    setUserAvatar(store, avatar) {
      store.allUser.find((user) => user.id == store.user.id).avatar = avatar
    },
    setLoading: (state, load) => (state.loading = load),
    setMaxFileSize: (state, value) => (state.maxFileSize = value),
    setMessage: (state, msg) => (state.message = msg),
    setToastMsg: (state, msgData) => (state.toastMsg = msgData),
    setUserCurrentApp(state, title) {
      // get app values
      let app = state.allApps.find((app) => app.id == title)
      // set app values by user
      Vue.set(state.user, 'app', {
        title: '',
        right: '',
        color: '',
        options: [],
        splitRights: [],
        disabled: true,
      })

      state.admin = false

      state.user.app.title = title
      state.user.app.right = state.user.rights[title]
      state.user.app.color = app ? app.color : '#FF595E'
      state.user.app.options = app ? app.options : {}
      // add splitted rights
      state.user.app.splitRights =
        app !== undefined
          ? app.userRights
              .map((right, i) => {
                if (i > 0 && state.user.app.right & Math.pow(2, i))
                  return { name: right, value: Math.pow(2, i) }
              })
              .filter(Boolean)
          : []
      // splitted rights add rights sum
      state.user.app.splitRights.push({
        name: 'ALL',
        value: state.user.app.right,
      })
      state.user.app.disabled = app !== undefined ? app.disabled : true
    },
    setAppOptions: (state, options) => (state.user.app.options = options),
    setSearchField: (state, value) => (state.searchField = value.trimStart()),
    setSearchHistory: (state, value) => {
      // Wenn der Wert bereits im Array ist, entferne ihn
      const index = state.searchHistory.indexOf(value)
      if (index !== -1) {
        state.searchHistory.splice(index, 1)
      }

      // Füge den Wert an den Anfang ein
      state.searchHistory.unshift(value)
      // save in session
      sessionStorage.setItem(
        'searchHistory',
        JSON.stringify(state.searchHistory)
      )
    },
    setDateField: (state, value) => (state.dateField = value),
    setNumberField: (state, value) => (state.numberField = value),
    setCronjob(state, value) {
      state.cronjob = value
      sessionStorage.setItem('cronjob', value)
    },
    // eventSource
    initLoginSource(state) {
      if (!state.loginSource) {
        console.log('start eventsource for logged user')
        // eventSource for logged user
        state.loginSource = new EventSource(
          process.env.VUE_APP_HOME +
            'api/pisa/user/noauth/online?userId=' +
            state.user.id
        )
        // add message event
        state.loginSource.onmessage = (event) => {
          // set online status
          state.allUser.forEach((user) => {
            if (user.status.online === undefined)
              Vue.prototype.$set(user.status, 'online', false)
            user.status.online = JSON.parse(event.data).includes(user.id)
          })
        }
      }
    },
    closeLoginSource(state) {
      console.log('stop loginSource')
      state.loginSource.close()
    },
    // helper
    setWindowHeight(state, value) {
      state.windowHeight = value
    },
  },
  actions: {
    // Helper
    saveUserClick({ state }, data) {
      Vue.prototype.$axios.post('pisa/online/click', {
        userId: state.user.id,
        app: data.app,
        page: data.page,
      })
    },
    async debounceSearchField({ commit }, value) {
      return new Promise((resolve) => {
        // cancel pending call
        clearTimeout(this._timerId)
        // delay new call 300ms
        this._timerId = setTimeout(
          () => {
            resolve(commit('setSearchField', value))
          },
          value != '' ? 300 : 0
        )
      })
    },
    saveAppOptions({ commit, state }, options) {
      Vue.prototype.$axios
        .put('pisa/app', {
          id: state.user.app.title,
          options: options,
        })
        .then(() => commit('setAppOptions', options))
    },
    // Login
    login({ commit, state }, user) {
      Vue.prototype.$axios.post('pisa/user/noauth/login', user).then((res) => {
        if (res.data) {
          commit('setLoggedIn', user.username)
          // if checkbox checked then set cookie
          if (user.remember) commit('setCookie')
          // redirect
          if (state.redirectPath != '') return router.push(state.redirectPath)
          else return router.push('/')
        } else {
          commit(
            'setMessage',
            'Benutzername oder Passwort falsch oder Benutzer gesperrt!'
          )
        }
      })
    },
    hasCookie({ commit }) {
      return Vue.prototype.$axios
        .get('pisa/user/noauth/cookie', { withCredentials: true })
        .then((res) => {
          if (res.data !== '') {
            commit('setLoggedIn', res.data)
            return true
          } else {
            return false
          }
        })
    },
    async loadUserData({ dispatch }) {
      dispatch('getAllUser')
      await Promise.all([
        dispatch('getApps'),
        dispatch('getUserData'),
        dispatch('getMaxFileSize'),
      ])
    },
    getApps({ commit }) {
      return Vue.prototype.$axios.get('pisa/app/noauth').then((res) => {
        commit('setAllApps', res.data)
      })
    },
    getUserData({ commit, getters }) {
      return Vue.prototype.$axios
        .get('pisa/user/noauth/' + getters.loggedIn)
        .then((res) => {
          if (JSON.stringify(res.data) !== '{}') {
            commit('setUser', res.data)
            commit('initLoginSource')
          } else return false
        })
    },
    getMaxFileSize({ commit }) {
      return Vue.prototype.$axios
        .get('pisa/file/noauth/maxfilesize')
        .then((res) => {
          commit('setMaxFileSize', res.data)
        })
    },
    getAllUser({ commit, state }) {
      if (state.allUser.length == 0) {
        return Vue.prototype.$axios.get('pisa/user/noauth/all').then((res) => {
          commit('setAllUser', res.data)
        })
      }
    },
    isCronjob({ commit, state }) {
      if (state.cronjob == 'true' || state.cronjob == true) {
        return Vue.prototype.$axios
          .get('pisa/online/cronjob/' + state.user.id)
          .then((res) => {
            commit('setCronjob', res.data)
            return state.cronjob
          })
      } else return false
    },
    logout({ commit }) {
      commit('setLoggedIn', '')
      commit('setAllApps', [])
      commit('setAllUser', [])
      commit('setUser', null)
      commit('setMessage', '')
      commit('setRedirectPath', '')
      commit('closeLoginSource')
      sessionStorage.clear()
      cookie.remove('remember')
      router.push('/login')
    },
  },

  modules: { crm, elvira, fpm, pda, plan, prm, ptb, qmd, time },
})
